/**
 * @file lib/testimonials.js
 */

import * as Avatars from "../img/avatar-*.png";

const Testimonials = [
  {
    image: Avatars["anisha"],
    name: "Anisha Li",
    quote:
      "Manage has supercharged our team’s workflow. The ability to maintain visibility on larger milestones at all times keeps everyone motivated.",
  },
  {
    image: Avatars["ali"],
    name: "Ali Bravo",
    quote:
      "We have been able to cancel so many other subscriptions since using Manage. There is no more cross-channel confusion and everyone is much more focused.",
  },
  {
    image: Avatars["richard"],
    name: "Richard Watts",
    quote:
      "Manage allows us to provide structure and process. It keeps us organized and focused. I can’t stop recommending them to everyone I talk to!",
  },
  {
    image: Avatars["shanai"],
    name: "Shanai Gough",
    quote:
      "Their software allows us to track, manage and collaborate on our projects from anywhere. It keeps the whole team in-sync without being intrusive.",
  },
];

export default Testimonials;
